export default function(totalPro) {
  return {
    type:"SET_TOTAL_PRO",
    totalPro
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosTotals/setProTotal.js